import type { IconSvgObject } from './types';

const CornerUpLeftIcon: IconSvgObject = [
  ["path", { d: "M5 9H12C15.7712 9 17.6569 9 18.8284 10.1716C20 11.3431 20 13.2288 20 17V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.99996 4C8.99996 4 4.00001 7.68245 4 9.00004C3.99999 10.3176 9 14 9 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerUpLeftIcon;
